import React from 'react';
import Modal from 'contexts/ModalContext/Modal';
import styled from 'styled-components';

const mentors: MentorProps[] = [
  {
    name: 'JK',
    summary: 'BCG, Project Manager (8년 근무)',
    descriptions: [
      { type: 'current', content: '스타트업, Founder' },
      { type: 'prev', content: 'Save the Children (1년 근무)' },
      { type: 'normal', content: '서울대학교 산업공학과 졸업' },
    ],
  },
  {
    name: 'Han',
    summary: 'BCG, Senior Associate (3년 근무)',
    descriptions: [
      { type: 'current', content: '스타트업, Product Lead' },
      { type: 'normal', content: '서울대학교 산업공학과 졸업' },
    ],
  },
  {
    name: 'Seo',
    summary: 'Bain, Consultant (3년 근무)',
    descriptions: [
      { type: 'current', content: '스타트업, CSO' },
      { type: 'prev', content: '국내 선도 대기업 지주사 (6년 근무)' },
      { type: 'normal', content: 'SKY 경제학과 졸업' },
    ],
  },
  {
    name: 'Hyun',
    summary: 'Bain, Associate Consultant (3년 근무)',
    descriptions: [
      { type: 'current', content: 'B2B AI 스타트업, 사업 기획 리드' },
      { type: 'normal', content: '고려대학교 심리학과/경영학과 졸업' },
    ],
  },
  {
    name: 'Daniel',
    summary: 'BCG, Senior Associate (2년 근무)',
    descriptions: [
      { type: 'current', content: '스타트업, Founder' },
      { type: 'normal', content: '고려대학교 경제학과 졸업' },
    ],
  },
  {
    name: 'Tigran',
    summary: '맥킨지, Associate (2년 근무)',
    descriptions: [
      { type: 'current', content: 'B2B 스타트업, Founder' },
      { type: 'normal', content: '버클리 MBA 졸업' },
    ],
  },
  {
    name: 'John',
    summary: 'MBB, 재직예정',
    descriptions: [
      { type: 'normal', content: '24년 하반기 MBB 중 2곳 동시합격' },
      { type: 'normal', content: '서울대학교 졸업' },
    ],
  },
];

function InterviewMasterClassBasicMentorsModal() {
  return (
    <Modal title='멘토 소개' maxWidth={454}>
      {mentors.map((mentor) => (
        <Mentor
          key={mentor.name}
          name={mentor.name}
          summary={mentor.summary}
          descriptions={mentor.descriptions}
        />
      ))}
    </Modal>
  );
}

interface MentorProps {
  name: string;
  summary: string;
  descriptions: { type: 'normal' | 'prev' | 'current'; content: string }[];
}

function Mentor({ name, summary, descriptions }: MentorProps) {
  return (
    <StyledMentor>
      <div className='name'>{name}</div>
      <div className='info'>
        <div className='summary'>{summary}</div>
        <ul className='descriptions'>
          {descriptions.map((description) => (
            <li key={description.content} className='description' data-type={description.type}>
              {description.content}
            </li>
          ))}
        </ul>
      </div>
    </StyledMentor>
  );
}

const StyledMentor = styled.div`
  display: grid;
  grid-template-columns: 1fr minmax(max-content, 280px);
  padding: 28px 0px;
  border-bottom: 1px solid #e8e8e8;

  &:first-of-type {
    padding-top: 0;
  }

  &:last-of-type {
    padding-bottom: 0;
    border-bottom: none;
  }

  > .name {
    font-size: 15px;
    font-weight: 600;
    color: black;
  }

  > .info {
    display: flex;
    flex-direction: column;
    row-gap: 10px;

    > .summary {
      font-size: 15px;
      font-weight: 500;
      color: black;
    }

    > .descriptions {
      list-style: none;
      padding-left: 0;
      font-size: 15px;
      font-weight: 500;
      margin: 0;
      color: #555;
      display: flex;
      flex-direction: column;
      row-gap: 4px;
      line-height: 1.2;

      > .description {
        &[data-type='current'] {
          ::before {
            content: '현';
            color: #3cac40;
            padding-right: 10px;
          }
        }
        &[data-type='prev'] {
          ::before {
            content: '전';
            color: #999;
            padding-right: 10px;
          }
        }
      }
    }
  }
`;

export default InterviewMasterClassBasicMentorsModal;
